import gql from "graphql-tag";

export const joinGamePlayGQL = gql`
  mutation JoinGamePlay($input: JoinGamePlayInput!) {
    joinGamePlay(input: $input) {
      message
      gameSession {
        id
        status
        launchData {
          ... on CasualHtmlLaunchData {
            __typename
            gameConfig
            launchUrl
          }
          ... on N2IStreamLaunchData {
            __typename
            launchUrl
            sessionId
          }
          ... on PCStreamLaunchData {
            __typename
            launchUrl
            streamStatusUrl
          }
          ... on BlacknutStreamLaunchData {
            __typename
            accessToken
            blacknutGameId
            refreshToken
          }
        }
        game {
          data
          id
          type
          orientation
        }
      }
      gamePlay {
        status
        id
        mode
      }
      gameParticipant {
        id
        status
      }
    }
  }
`;

export const startGamePlayGQL = gql`
  mutation startGamePlay($input: StartGamePlayInput) {
    startGamePlay(input: $input) {
      message
    }
  }
`;

export const endGamePlayGql = gql`
  mutation endGamePlay($input: EndGamePlayInput!) {
    endGamePlay(input: $input) {
      gameParticipant {
        id
        status
        prize {
          amount
          itemType
          walletType
        }
      }
      gamePlay {
        id
        mode
        status
      }
      gameSession {
        id
        status
      }
    }
  }
`;
